import styled from "styled-components";
import dropDownArrowIcon from "../../../assets/icons/dropDownArrowIcon.svg";
import { pxToRem } from "../../../styles/utils";

export const CellDropdownContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const CellDropdownInput = styled.input`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(18)};
  font-weight: 400;
  border: none;
  outline: none;

  &:focus {
    border: none;
    outline: none;
  }
`;

export const CellDropdownIcon = styled.span<{ isOpen: boolean }>`
  position: absolute;
  right: ${pxToRem(113)};
  top: 50%;
  transform: translateY(-50%)
    rotate(${({ isOpen }) => (isOpen ? "0deg" : "180deg")});
  transition: transform 0.2s ease-in-out;
  width: ${pxToRem(16)};
  height: ${pxToRem(16)};
  background: url(${dropDownArrowIcon}) no-repeat center center;
  background-size: contain;
  cursor: pointer;
`;

export const CellDropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border-radius: ${pxToRem(24)};
  box-shadow: ${pxToRem(4)} ${pxToRem(4)} ${pxToRem(14)} 0px rgba(202, 202, 202, 0.25),
    ${pxToRem(-4)} ${pxToRem(-4)} ${pxToRem(14)} 0px rgba(202, 202, 202, 0.25);
  background: rgb(255, 255, 255);
  padding: ${pxToRem(20)};
  z-index: 10000;
  width: auto;

  /* Ограничиваем высоту и включаем прокрутку */
  max-height: ${pxToRem(150)}; /* Ограничьте высоту списка */
  overflow-y: scroll; /* Включаем вертикальную прокрутку */

  /* Убираем скроллбар */
  &::-webkit-scrollbar {
    display: none; /* Скрываем скроллбар для браузеров с поддержкой Webkit */
  }
  -ms-overflow-style: none; /* Скрываем скроллбар для IE и Edge */
  scrollbar-width: none; /* Скрываем скроллбар для Firefox */
`;

export const CellDropdownItem = styled.li`
  cursor: pointer;
  list-style: none;
  color: rgb(39, 39, 39);
  font-family: ${({ theme }) => theme.fonts.mont};
  font-size: ${pxToRem(16)};
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: left;
  padding: ${pxToRem(10)};
  border-bottom: ${pxToRem(1)} solid rgba(0, 0, 0, 0.1);

  &:hover {
    color: rgb(114, 82, 220);
  }
`;
